import React from 'react';

export const Spinner = () => <div className="lds-dual-ring" />;
